<script>
  import notifications from "@store/notifications"
  import Notification from "@components/Notification.svelte"
  import { router } from "@inertiajs/svelte"
  import { onDestroy } from "svelte"

  function handleFlash(flash) {
    if (flash?.info) {
      notifications.success({ type: "info", message: flash.info })
    }

    if (flash?.success) {
      notifications.success({ message: flash.success })
    }

    if (flash?.warn) {
      notifications.success({ type: "warn", message: flash.warn })
    }

    if (flash?.error) {
      notifications.error({ message: flash.error })
    }
  }

  // Handle flash via shared props on navigation
  const removeNavigateListener = router.on("navigate", (event) => {
    handleFlash(event.detail.page.props.flash)
  })

  // Handle flash on successful requests (including redirects to same page)
  const removeSuccessListener = router.on("success", (event) => {
    handleFlash(event.detail.page.props.flash)
  })

  // Handle Inertia v2 flash data (flash event)
  const removeFlashListener = router.on("flash", (event) => {
    handleFlash(event.detail.flash)
  })

  onDestroy(() => {
    removeNavigateListener()
    removeSuccessListener()
    removeFlashListener()
  })
</script>

{#if $notifications.length > 0}
  <div class="c-notification-drawer [ fixed bottom-4 right-4 space-y-4 z-notification max-w-[350px] w-full ]">
    {#each $notifications as notification (notification.id)}
      <Notification {notification} />
    {/each}
  </div>
{/if}
